const stepsList = ['表单样式', '流程设计']

const typeMap = {
  1: {
    color: '#ED6A0C',
    cName: '审批人',
  },
  2: {
    color: '#ED6A0C',
    cName: '审批人',
  },
  3: {
    color: '#ED6A0C',
    cName: '审批人',
  },
  4: {
    color: '#5496FF',
    cName: '抄送人',
  },
  5: {
    color: '#1A4DA0',
    cName: '发起人',
  },
  6: {
    color: '#F0FAF2',
    cName: '条件',
  },
}

const nodeTypeMap = {
  SINGLE_APPROVE: 1,
  MULTIPLE_AND: 2,
  MULTIPLE_OR: 3,
  CC_APPROVE: 4,
}

const nodeTypeList = [
  {
    label: '单人审批',
    value: nodeTypeMap.SINGLE_APPROVE,
  },
  {
    label: '多人审批',
    value: nodeTypeMap.MULTIPLE_AND,
  },
  {
    label: '抄送',
    value: nodeTypeMap.CC_APPROVE,
  },
]

const approvalMethodList = [
  {
    label: '会签',
    value: nodeTypeMap.MULTIPLE_AND,
  },
  {
    label: '或签',
    value: nodeTypeMap.MULTIPLE_OR,
  },
]
export const auditFlowManageConfig = {
  stepsList,
  typeMap,
  nodeTypeMap,
  nodeTypeList,
  approvalMethodList,
}
